import React from "react";
import Typography from "@material-ui/core/Typography";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Money from '../../../common/Money';

const NumberCell = ({name, value}) => {
    return <TableRow>
        <TableCell>
            <Typography variant='body2'>{name}</Typography>
        </TableCell>
        <TableCell align='right'>
            <Money value={value}/>
        </TableCell>
    </TableRow>
};

export default NumberCell;